import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { Box, Button, Typography } from "@mui/material";

type Props = {
  selectedCount: number;
  disabled?: boolean;
  canDelete?: boolean;
  onDownload: () => void;
  onDelete?: () => void;
};

export function FileBulkToolbar({
  selectedCount,
  disabled = false,
  canDelete = false,
  onDownload,
  onDelete,
}: Props) {
  if (selectedCount === 0) return null;

  const label = selectedCount === 1 ? "arquivo selecionado" : "arquivos selecionados";

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      px={2}
      py={1.5}
      mt={2}
      border="1px solid #BFDBFE"
      borderRadius={1}
      bgcolor="#EFF6FF"
    >
      <Typography fontSize={14} fontWeight={500} color="#1E40AF">
        {selectedCount} {label}
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadOutlinedIcon />}
          onClick={onDownload}
          disabled={disabled}
          sx={{ textTransform: "none", bgcolor: "#FFFFFF" }}
        >
          Download
        </Button>
        {canDelete && onDelete && (
          <Button
            size="small"
            variant="outlined"
            color="error"
            startIcon={<DeleteOutlineIcon />}
            onClick={onDelete}
            disabled={disabled}
            sx={{ textTransform: "none", bgcolor: "#FFFFFF" }}
          >
            Excluir
          </Button>
        )}
      </Box>
    </Box>
  );
}
